import "./LocalSeoConsultantTelford.module.css";
import Header from "@/reusable_sections/Header";
import Consultation from "./sections/Consultation";
import Services from "./sections/Services";
import Benefits from "./sections/Benefits";
import Casestudyimpact from "./sections/Casestudyimpact";
import Serviceofferingsgrid from "./sections/Serviceofferingsgrid";
import Methodology from "./sections/Methodology";
import Localauthority from "./sections/Localauthority";
import Telford from "./sections/Telford";
import TelfordMarket from "./sections/TelfordMarket";
import Telfordfaq from "./sections/Telfordfaq";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantTelfordPage() {
  return <div>
      <Header />
      <Consultation />
      <Services />
      <Benefits />
      <Casestudyimpact />
      <Serviceofferingsgrid />
      <Methodology />
      <Localauthority />
      <Telford />
      <TelfordMarket />
      <Telfordfaq />
      <Footer />
    </div>;
}